import { createSelector } from "reselect";
const selectHomeState = createSelector((state) => state.home, state => state);
const selectHome = createSelector(selectHomeState, state => state.infos);
export { selectHome };
